import "./app.css";
import AppRoutes from "./Routes";

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
